import useValidatedSearchParams from '../../../../router/useValidatedSearchParams';
import { Filter } from './Filters';
import { Switch, Text } from '@mantine/core';
import classes from './Filters.module.css';

const SwitchFilter = <T,>({ filter }: { filter: Filter<T> }) => {
  const {
    validatedParams,
    setValidatedParam,
    SEARCH_PARAMS_KEYS: { PLOT_ID },
  } = useValidatedSearchParams();

  const isActive = validatedParams[filter.key] === 'true';

  const handleFilterChange = () => {
    setValidatedParam(filter.key, isActive ? null : 'true');
    setValidatedParam(PLOT_ID, null);
  };

  return (
    <Switch
      checked={isActive}
      classNames={{ body: classes.switch }}
      label={<Text size="lg">{filter.label}</Text>}
      labelPosition="left"
      size="md"
      onChange={handleFilterChange}
    />
  );
};

export default SwitchFilter;
